import $ from 'jquery';
import 'bootstrap';
import 'slick-carousel';

console.clear();

const app = (() => {
	let body;
	let menu;
	let menuItems;

	const init = () => {
		body = document.querySelector('body');
		menu = document.querySelector('.menu-icon');
		menuItems = document.querySelectorAll('.nav__list-item');
		applyListeners();
	};

	const applyListeners = () => {
		menu.addEventListener('click', () => toggleClass(body, 'nav-active'));
	};

	const toggleClass = (element, stringClass) => {
		if (element.classList.contains(stringClass)) {
			element.classList.remove(stringClass);
		} else {
			element.classList.add(stringClass);
		}
	};

	init();
})();

$(() => {

	$('.single-item').slick({
		arrows: false,
		fade: true,
		dots: true,
		speed: 3000,
		slidesToShow: 1,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 2000,
	});

	$('.lan').on('click', function () {
		let lan = $(this).data('info');
		let getUrl = location.href;
		if (lan === "") {

		} else {
			let post_url = lan + getUrl;
			window.open(post_url, '_blank');
		}
	});
});
